import { render, staticRenderFns } from "./arrow_left.vue?vue&type=template&id=01ccff9c&"
import script from "./arrow_left.vue?vue&type=script&lang=js&"
export * from "./arrow_left.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports